import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "display"]

  update() {
    this.displayTarget.textContent = this.inputTarget.value
  }
}
